"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreInfo = exports.ReadMoreButton = exports.Link = exports.TextBlock = exports.PartNumber = exports.Price = exports.PkgAmountBlock = exports.Title = exports.GradientOverlay = exports.LogoContainer = exports.TextBlockWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@/Components/UI/Typography"));
const Types_1 = require("@/Types");
const Button_1 = __importDefault(require("@/Components/Button"));
exports.TextBlockWrapper = styled_components_1.default.div `
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `margin: 0 ${props.theme.spacing.m3}px;
     max-width: ${props.theme.constants.blockHeight.m7}px;
     
     @media (max-width: ${props.theme.breakpoints.lg}px) {
      margin: 0 ${props.theme.spacing.s4}px;
      max-width: ${props.theme.constants.blockHeight.m2}px;
     }
     `}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `max-width: ${props.theme.constants.blockHeight.s6}px;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `width: 100%;`}

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW &&
    `
      width: 100%;
      max-width: initial;
      margin: ${props.theme.spacing.s4}px 0;
      align-self: flex-start;
    `}
  }
`;
exports.LogoContainer = styled_components_1.default.span `
  margin-right: ${props => props.theme.spacing.s4}px;
`;
exports.GradientOverlay = styled_components_1.default.div `
  background: ${props => props.theme.palette.DESCRIPTION_OVERLAY};
  width: 100%;
  height: ${props => props.theme.constants.descriptionOverlayHeight.md}px;
  position: absolute;
  bottom: 0;
  z-index: ${props => props.theme.attributes.zIndex.gradientOverlay};
  ${props => !props.showGradient && 'display: none;'}
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW && `margin-bottom: ${props.theme.spacing.s2}px;`}
  ${props => props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW && `margin-bottom: ${props.theme.spacing.s1}px;`}
${props => props.variantType === Types_1.VariantTypes.SEARCH_VIEW &&
    `
  margin-bottom: ${props.theme.spacing.s1}px;
  &:hover {
    text-decoration: underline;
  }
`}
${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `font-weight: ${props.theme.typography.weight.regular};`}
color: ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.PkgAmountBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  margin-bottom: ${props => props.theme.spacing.s2}px;
  > h5 {
    margin-right: ${props => props.theme.spacing.s1}px;
  }
  > div {
    margin-left: ${props => props.theme.spacing.s1}px;
  }
`;
exports.Price = (0, styled_components_1.default)(Typography_1.default) `
  ${props => (props.variantType === Types_1.VariantTypes.CAROUSEL_VIEW || props.variantType === Types_1.VariantTypes.FULL_VIEW) &&
    `color: ${props.theme.palette.LIGHT_BLACK};`}
  ${props => props.variantType === Types_1.VariantTypes.MINI_CART_VIEW && `color: ${props.theme.palette.DARK_GRAY_100};`}
  display: inline-block;
  margin: 0;
`;
exports.PartNumber = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.DARK_GRAY_80};
  ${props => props.variantType === Types_1.VariantTypes.FULL_VIEW && `margin-bottom: ${props.theme.spacing.s2}px;`}
`;
exports.TextBlock = styled_components_1.default.div `
  position: relative;
  transition: ${props => props.theme.animations.primary};
  overflow: hidden;
`;
exports.Link = styled_components_1.default.a `
  color: ${props => props.theme.palette.LIGHT_BLACK};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.ORANGE_100};
    outline-offset: -2px;
  }
`;
exports.ReadMoreButton = (0, styled_components_1.default)(Button_1.default) `
  text-decoration: underline !important;
  margin-top: ${props => props.theme.spacing.s2}px;
  white-space: nowrap;
  font-weight: ${props => props.theme.typography.weight.regular};
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  font-size: ${props => props.theme.typography.size.s2}px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.ORANGE_100};
  }

  svg {
    display: none;
  }
`;
exports.CoreInfo = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.bold};
  color: ${props => props.theme.palette.LIGHT_BLACK};
  line-height: ${props => props.theme.typography.lineHeight.s6}px;
`;
exports.default = {
    TextBlockWrapper: exports.TextBlockWrapper
};
